import { CampaignPrefillResponse, StoredCampaignPrefill } from "../types/campaignPrefill";
import { buildWizardDataFromPrefill } from "./applyCampaignPrefillToWizard";

export const CAMPAIGN_PREFILL_STORAGE_KEY = "CampaignPrefillData";

export function clearCampaignWizardStorage() {
  try {
    localStorage.removeItem("CompaignData");
    localStorage.removeItem("campaignData");
  } catch {
    // ignore storage errors
  }
}

export function clearCampaignPrefillStorage() {
  try {
    localStorage.removeItem(CAMPAIGN_PREFILL_STORAGE_KEY);
  } catch {
    // ignore storage errors
  }
}

export function saveCampaignPrefill(
  jobSpecificationId: number,
  prefill: CampaignPrefillResponse
) {
  const stored: StoredCampaignPrefill = {
    jobSpecificationId,
    prefill,
    fetchedAt: new Date().toISOString(),
  };

  localStorage.setItem(CAMPAIGN_PREFILL_STORAGE_KEY, JSON.stringify(stored));

  const wizardData = buildWizardDataFromPrefill(prefill, jobSpecificationId);
  localStorage.setItem("CompaignData", JSON.stringify(wizardData));
}

export function getStoredCampaignPrefill(): StoredCampaignPrefill | null {
  try {
    const raw = localStorage.getItem(CAMPAIGN_PREFILL_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as StoredCampaignPrefill;
  } catch {
    return null;
  }
}

export function seedCampaignPrefillForJob(
  jobSpecificationId: number,
  prefill: CampaignPrefillResponse
) {
  clearCampaignWizardStorage();
  clearCampaignPrefillStorage();
  saveCampaignPrefill(jobSpecificationId, prefill);
}
